import { useEffect, useState } from "react";

import { toastify } from "@src/utility/helpers/toast";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useSubmit = () => {
    const { platformId } = useParams();    
    const [survey, setSurvey] = useState(null);
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedRating, setSelectedRating] = useState(null);
    const [additionalComment, setAdditionalComment] = useState("");

    const { getSearchParams } = useSearchParams();

    const survey_id = getSearchParams("survey_id");
    const people_id = getSearchParams("people_id");
    const orid = getSearchParams("orid");

    const submitSurvey = async (survey_id, people_id, orid, pid, surveyResponse) => {
        await axiosInstance.post("/survey/response", surveyResponse, {
            params: {
                survey_id,
                people_id,
                orid,
                pid
            }
        });
    };

    const getSurvey = async (survey_id) => {
        const { data } = await axiosInstance.get(`/survey/detail?survey_id=${survey_id}&orid=${orid}&pid=${platformId}`);
        setSurvey(data || null);
    };
    
    useEffect(() => {
        if (survey_id) {
            getSurvey(survey_id);
        }
        return () => {
            cancelAllRequests();
        };
    }, [survey_id]);

    const handleSubmit = () => {
        if (selectedRating === null) {
            toastify({
                type : "error",
                title: "Please select a rating"
            });
            return;
        }
        const surveyResponse = {
            rating            : selectedRating,
            additional_comment: additionalComment
        };
        submitSurvey(survey_id, people_id, orid, surveyResponse);
        setIsSubmitted(true);
    };

    return {
        loading,
        getSurvey,
        submitSurvey,
        isSubmitted,
        setSelectedRating,
        handleSubmit,
        setAdditionalComment,
        survey,
        selectedRating
    };
};
export default useSubmit;